
/**
 * @see "Section 7.1.5, OFX Spec"
 */
export enum ClientRoutingCapability {

  NONE,

  SERVICE,

  MESSAGE_SET
}
